import script from "./InformationManager.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationManager.vue?vue&type=script&setup=true&lang=js"

import "./InformationManager.vue?vue&type=style&index=0&id=5d89ed86&lang=scss"

const __exports__ = script;

export default __exports__